import { createContext } from 'react'
import noop from 'lib/function/noop'
import type { LuxKitModalBehaviourDispatchAction } from './LuxKitModalBehaviourState'
import type LuxKitModalBehaviourState from './LuxKitModalBehaviourState'
import { MODAL_BEHAVIOUR_INITIAL_STATE } from './LuxKitModalBehaviourState'

export const LuxKitModalBehaviourStateContext = createContext<LuxKitModalBehaviourState>(MODAL_BEHAVIOUR_INITIAL_STATE)
export const LuxKitModalBehaviourDispatchContext = createContext<React.Dispatch<LuxKitModalBehaviourDispatchAction>>(noop)
